import { memo } from "react";
import { BoletoHeaderText, ContractLoading } from "../../../styles/Boleto";
import { enumContractStatus } from "../../Status";

const ContractStatus = ({ status, hasError }) => (
  <BoletoHeaderText>
    Status
    {hasError ? (
      " - "
    ) : status ? (
      enumContractStatus[status]
    ) : (
      <ContractLoading />
    )}
  </BoletoHeaderText>
);

export default memo(ContractStatus);
